import {Base} from '@/dto/Base';
import {Openfire} from "@/entity/Openfire";

export class OpenfireDto {
    public static url = '/openfire';

    public static async addZiZhangHao(openfire: Openfire){
        await Base.postWithToken(this.url + '/addZiZhangHao', openfire);
    }

    public static async deleteZiZhangHao(openfire: Openfire){
        await Base.postWithToken(this.url + '/deleteZiZhangHao', openfire);
    }
}
